<template>

    <v-form ref="form" v-model="component.validLegal">
  
      <!-- <v-row v-if="component.out_of_register">
  
        <v-col cols="6">
  
          <v-select label="Empresa" :items="listEnterprise" v-model="selectedEnterprise" outlined item-text="fantasyName"
  
            item-value="id"></v-select>
  
        </v-col>
  
      </v-row> -->
  
      <v-row>
  
        <v-col cols="6">
  
          <v-text-field v-model="component.LegalPeople.socialName" label="*Razão Social" :rules="textRules" outlined>
  
          </v-text-field>
  
        </v-col>
  
        <v-col cols="6">
  
          <v-text-field v-model="component.LegalPeople.fantasyName" label="*Nome Fantasia" :rules="textRules" outlined>
  
          </v-text-field>
  
        </v-col>
  
      </v-row>
  
      <v-row>
  
        <v-col cols="3">
  
          <v-text-field v-model="component.LegalPeople.cnpj" label="*CNPJ" v-mask="'NN.NNN.NNN/NNNN-##'"
  
            :rules="[cnpjRule]" outlined></v-text-field>
  
        </v-col>
  
        <v-col cols="3">
  
          <v-text-field v-model="component.LegalPeople.stateRegistration" label="*Inscrição Estadual" :rules="textRules"
  
            outlined @blur="checkStateRegistration()"></v-text-field>
  
        </v-col>
  
      </v-row>
  
      <v-row>
  
         <v-col cols="4">
  
           <v-text-field
  
             v-model="component.contact.cellPhone"
  
             label="*Telefone Celular"
  
             :rules="textRules"
  
             hint="Exemplo: (12) 3 4567-8901"
  
             v-mask="'(##) # ####-####'"
  
             outlined
  
           ></v-text-field>
  
         </v-col>
  
       </v-row>
  
    </v-form>
  
  </template>
  
  <script>
  
  import { GET_ALL_ENTERPRISE, SELECTED_ENTERPRISE } from "@/store/actions/enterprise"
  
  import { mapGetters } from "vuex";

  import { cnpjRule } from "@/utils/validators";

  export default {
  
    computed: {
  
      ...mapGetters(["getShowDialogRegisterClient", "getSelectedEnterprise", "getEnterprises"]),
  
    },
  
    props: { component: Object() },
  
    data: () => ({
  
      selectedEnterprise: Object(),
  
      listEnterprise: Array(),
  
      textRules: [(v) => !!v || "Campo obrigatório!"],
  
    }),
  
    methods: {
  
      getAllInformations(page = null) {
  
        var payload = {
  
          page: page, limit: null, paginate: false
  
        }
  
        this.$store.dispatch(GET_ALL_ENTERPRISE, payload)
  
      },
  
      reset() {
  
        this.$refs.form.resetValidation();
  
      },
  
    cnpjRule,

      checkStateRegistration() {
  
        if(this.component.LegalPeople.stateRegistration == "") {
  
          this.component.LegalPeople.stateRegistration = "ISENTO"
  
        }
  
      }
  
    },
  
    watch: {
  
      // selectedEnterprise: function () {
  
      //   this.$store.dispatch(SELECTED_ENTERPRISE, this.selectedEnterprise)
  
      // },
  
      // getEnterprises: function (value) {
  
      //   if(value){
  
      //     //console.log(value);
  
      //     this.listEnterprise = Object.values(value)
  
      //     this.selectedEnterprise = this.listEnterprise[0]
  
      //   }
  
      // },
  
    },
  
    created() {
  
      // this.getAllInformations()
  
    },
  
  };
  
  </script>
  
  <style>
  
  </style>
  